<template>
    <svg viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
            d="M9.02045 3.12728C8.30227 2.26547 7.22499 1.69092 5.96818 1.69092C3.99319 1.69092 2.37728 3.63001 2.37728 6C2.37728 8.37 3.99319 10.3091 5.96818 10.3091C7.22499 10.3091 8.30227 9.73453 9.02045 8.87272M1.47955 4.92274H6.50682M1.47955 7.07727H6.50682"
            stroke="currentColor"
            stroke-width="1.5"
            stroke-linecap="round"
            stroke-linejoin="round" />
    </svg>
</template>
